// extracted by mini-css-extract-plugin
export default {"animate":"Styles_animate__WACcK","grow":"Styles_grow__NDJjQ","fadeIn":"Styles_fadeIn__XDuFZ"};